import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';

export interface UmpirePageTypeComponentType {
  client_id: string;
  component_type: UmpireComponentTypeEnum;
  created_at: Date | string;
  id: string;
  kind: 'page_type';
  name: string;
  type: 'component_type';
}
